// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3ldgP","colMin":"styles_colMin__jB_CV","colCheckbox":"styles_colCheckbox__1qZYY"};